import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './MakeToStoreComment.less';

export default class MakeToStoreComment extends OfficialPage {
  state = {
    goodsInfo: [],
    submitData: {
      order_id: '',
      goods: [],
      tostore_score: 5,
      tostore_environment_score: 5,
      tostore_seller_serve_score: 5
    }
  }

  constructor(props) {
    super(props);
    document.title = '评价';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      'submitData.order_id': options.detail,
      'submitData.sub_shop_app_id': options.franchisee || ''
    })
    this.getOrderDetail()
  }

  getOrderDetail = () => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: that.data.submitData.order_id,
        sub_shop_app_id: this.data.submitData.sub_shop_app_id
      },
      success: function (res) {
        var goodsInfo = res.data[0].form_data.goods_info,
          goods = []
        for (var i = 0, j = goodsInfo.length - 1; i <= j; i++) {
          goods.push({
            goods_id: goodsInfo[i].goods_id,
            info: {
              content: '',
              level: 1,
              img_arr: []
            }
          })
        }
        that.setData({
          goodsInfo: goodsInfo,
          'submitData.goods': goods
        })
      }
    })
  }
  setTostoreScore = e => {
    var score = e.target.dataset.score
    this.setData({
      'submitData.tostore_score': score
    })
  }
  setTostoreEnvironmentScore = e => {
    var score = e.target.dataset.score
    this.setData({
      'submitData.tostore_environment_score': score
    })
  }
  setTostoreSellerServeScore = e => {
    var score = e.target.dataset.score
    this.setData({
      'submitData.tostore_seller_serve_score': score
    })
  }
  clickLevelSpan = e => {
    var goodsIndex = e.currentTarget.dataset.goodsIndex,
      level = e.currentTarget.dataset.level,
      data = {}
    data['submitData.goods[' + goodsIndex + '].info.level'] = level
    this.setData(data)
  }
  commentInput = e => {
    var goodsIndex = e.target.dataset.goodsIndex,
      data = {}
    data['submitData.goods[' + goodsIndex + '].info.content'] = e.target.value
    this.setData(data)
  }
  chooseImage = e => {
    var that = this,
      goodsIndex = e.currentTarget.dataset.goodsIndex,
      img_arr = that.data.submitData.goods[goodsIndex].info.img_arr
    if (img_arr.length >= 3) {
      app.showModal({
        content: '每个商品最多上传3张图片'
      })
      return
    }
    app.chooseImage(function (images) {
      var data = {}
      data[
        'submitData.goods[' + goodsIndex + '].info.img_arr'
      ] = img_arr.concat(images)
      that.setData(data)
    }, 3 - img_arr.length)
  }
  removePic = e => {
    var goodsIndex = e.currentTarget.dataset.goodsIndex,
      picIndex = e.currentTarget.dataset.picIndex,
      img_arr = this.data.submitData.goods[goodsIndex].info.img_arr,
      data = {}
    img_arr.splice(picIndex, 1)
    data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr
    this.setData(data)
  }
  makeComment = () => {
    var that = this,
      submitData = that.data.submitData,
      modalText = ''
    for (var i = submitData.goods.length - 1; i >= 0; i--) {
      var goods = submitData.goods[i]
      if (!goods.info.level) {
        modalText = '尚未给商品评分'
        break
      }
      if (goods.info.img_arr.length > 3) {
        modalText = '每个商品最多上传3张图片'
        break
      }
    }
    if (modalText) {
      app.showModal({
        content: modalText
      })
      return
    }
    let addTime = Date.now()
    app.sendRequest({
      url: '/index.php?r=AppShop/AddAssessList',
      method: 'post',
      data: submitData,
      success: function (res) {
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: { add_time: addTime },
          success: function (res) {
            if (res.status == 0) {
              app.showModal({
                content: '评论成功',
                confirm: function () {
                  app.turnBack()
                }
              })
            } else {
              that.setData({
                rewardPointObj: {
                  showModal: true,
                  count: res.data,
                  callback: 'turnBack'
                }
              })
            }
          }
        })
      }
    })
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      goodsInfo,
      submitData
    } = this.state
    return (
      <div className="official-page make-to-store-comment">
        <TopNav title="评价" />
        <React.Fragment>
          <div className="makeCom-wrap page" id="makeComment">
            {goodsInfo.map((item, goodsIndex) => {
              return (
                <div className="makeCom-item makeCom-goods-comment" key={goodsIndex}>
                  <div>
                    <img
                      className="makeCom-goods-cover"
                      src={item.cover}
                    />
                    <textarea
                      data-goods-index={goodsIndex}
                      onInput={this.commentInput}
                      className="makeCom-textarea"
                      placeholder="写下购买体会为其他小伙伴提供参考"
                    ></textarea>
                  </div>
                  <div className="makeCom-pic-container">
                    {submitData.goods[goodsIndex].info.img_arr.map(
                      (imgUrl, index) => {
                        return (
                          <div key={index} className="makeCom-pic-wrap">
                            <img src={imgUrl} mode="aspectFit" />
                            <label
                              className="makeCom-remove-pic"
                              onClick={this.removePic}
                              data-goods-index={goodsIndex}
                              data-pic-index={index}
                            >
                              ×
                            </label>
                          </div>
                        )
                      }
                    )}
                    <div
                      className="makeCom-upload-pic"
                      onClick={this.chooseImage}
                      data-goods-index={goodsIndex}
                    >
                      <div>＋</div>
                      <span>添加图片</span>
                    </div>
                  </div>
                  <div className="makeCom-level-container">
                    <label
                      className={
                        'makeCom-level-span ' +
                        (submitData.goods[goodsIndex].info.level == 1
                          ? 'active'
                          : '')
                      }
                      data-level="1"
                      data-goods-index={goodsIndex}
                      onClick={this.clickLevelSpan}
                    >
                      <label className="ico-moon icon-tostoreGoodComment"></label>
                      好评
                    </label>
                    <label
                      className={
                        'makeCom-level-span ' +
                        (submitData.goods[goodsIndex].info.level == 2
                          ? 'active'
                          : '')
                      }
                      data-level="2"
                      data-goods-index={goodsIndex}
                      onClick={this.clickLevelSpan}
                    >
                      <label className="ico-moon icon-tostoreMiddleComment"></label>
                      中评
                    </label>
                    <label
                      className={
                        'makeCom-level-span ' +
                        (submitData.goods[goodsIndex].info.level == 3
                          ? 'active'
                          : '')
                      }
                      data-level="3"
                      data-goods-index={goodsIndex}
                      onClick={this.clickLevelSpan}
                    >
                      <label className="ico-moon icon-tostoreBadComment"></label>
                      差评
                    </label>
                  </div>
                </div>
              )
            })}
            <div
              className="makeCom-item"
              style={convertLineStyleData('padding:10px; line-height:30px;')}
            >
              <div style={convertLineStyleData('font-size:16px;')}>店铺评分</div>
              <div>
                描述相符：
                <div className="makeCom-mark-container makeCom-fit-score">
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_score >= 1 ? '' : '-empty')
                    }
                    data-score="1"
                    onClick={this.setTostoreScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_score >= 2 ? '' : '-empty')
                    }
                    data-score="2"
                    onClick={this.setTostoreScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_score >= 3 ? '' : '-empty')
                    }
                    data-score="3"
                    onClick={this.setTostoreScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_score >= 4 ? '' : '-empty')
                    }
                    data-score="4"
                    onClick={this.setTostoreScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_score >= 5 ? '' : '-empty')
                    }
                    data-score="5"
                    onClick={this.setTostoreScore}
                  ></label>
                </div>
              </div>
              <div>
                店铺环境：
                <div className="makeCom-mark-container makeCom-logistics-score">
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_environment_score >= 1 ? '' : '-empty')
                    }
                    data-score="1"
                    onClick={this.setTostoreEnvironmentScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_environment_score >= 2 ? '' : '-empty')
                    }
                    data-score="2"
                    onClick={this.setTostoreEnvironmentScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_environment_score >= 3 ? '' : '-empty')
                    }
                    data-score="3"
                    onClick={this.setTostoreEnvironmentScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_environment_score >= 4 ? '' : '-empty')
                    }
                    data-score="4"
                    onClick={this.setTostoreEnvironmentScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_environment_score >= 5 ? '' : '-empty')
                    }
                    data-score="5"
                    onClick={this.setTostoreEnvironmentScore}
                  ></label>
                </div>
              </div>
              <div>
                商家服务：
                <div className="makeCom-mark-container makeCom-logistics-score">
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_seller_serve_score >= 1 ? '' : '-empty')
                    }
                    data-score="1"
                    onClick={this.setTostoreSellerServeScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_seller_serve_score >= 2 ? '' : '-empty')
                    }
                    data-score="2"
                    onClick={this.setTostoreSellerServeScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_seller_serve_score >= 3 ? '' : '-empty')
                    }
                    data-score="3"
                    onClick={this.setTostoreSellerServeScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_seller_serve_score >= 4 ? '' : '-empty')
                    }
                    data-score="4"
                    onClick={this.setTostoreSellerServeScore}
                  ></label>
                  <label
                    className={
                      'ico-moon icon-star' +
                      (submitData.tostore_seller_serve_score >= 5 ? '' : '-empty')
                    }
                    data-score="5"
                    onClick={this.setTostoreSellerServeScore}
                  ></label>
                </div>
              </div>
            </div>
            <div className="makeCom-bottom-nav" onClick={this.makeComment}>
              <label className="makeCom-make-comment btn btn-orange">
                发表评价
              </label>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/make-to-store-comment/MakeToStoreComment.jsx